import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Box, Tab, Tabs} from "@mui/material";
import {FullTable} from 'components';
import {
    shopifyErrorsBody,
    shopifyErrorsHead,
    shopifyPriceErrorsBody,
    shopifyPriceErrorsHead
} from './fragments/constants';
import {buttonsStyle} from "../amazon/fragments";
import {logsActions} from 'store';
import {SavePage} from "utils";


function tabProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const ShopifyErrors = () => {
    const {logs, priceErrors} = useSelector((state) => ({
        logs: state.logs.allLogs,
        priceErrors: state.logs.priceErrors,
    }));
    const [currentId, setCurrentId] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const info = history?.location?.state;
    const classes = buttonsStyle();

    const renderParams = () => {
        const filteredInfo = {
            ...info,
        };
        delete filteredInfo.page;
        delete filteredInfo.tab;

        return filteredInfo;
    }

    const handleGet = () => {
        const filteredInfo = renderParams();

        if (!info?.tab || info?.tab === 0) {
            if (info) {
                dispatch(logsActions.getLogsSku({...filteredInfo, store: 'SHOPIFY'}));
            }
        } else {
            dispatch(logsActions.getPriceErrors({...filteredInfo, store: 'SHOPIFY'}));
        }
    }

    useEffect(() => {
        handleGet();
    }, [info]);

    const handleChangeTabs = (event, newValue) => {
        SavePage(history, info, {tab: newValue});
    }

    const renderTable = () => {
        switch (info?.tab) {
            case 0:
                return {
                    head: shopifyErrorsHead,
                    body:shopifyErrorsBody(handleClickToButton, currentId),
                    actionType: 'GET_LOGS_SKU',
                    list: logs?.logs,
                    count: logs?.count,
                    noText: 'Order Errors',
                };

            case 1:
                return {
                    head: shopifyPriceErrorsHead,
                    body: shopifyPriceErrorsBody,
                    actionType: 'GET_PRICE_ERRORS',
                    list: priceErrors?.logs,
                    count: priceErrors?.count,
                    noText: 'Price Errors',
                };

            default:
                return {
                    head: shopifyErrorsHead,
                    body:shopifyErrorsBody(handleClickToButton, currentId),
                    actionType: 'GET_LOGS_SKU',
                    list: logs?.logs,
                    count: logs?.count,
                    noText: 'Order Errors',
                };
        }
    };

    const handleClickToButton = (item) => {
        setCurrentId(item.id);
        const filteredInfo = renderParams();
        dispatch(logsActions.resolveLogsSku({...filteredInfo, store: 'SHOPIFY'}, item.id));
    };

    const renderTableValues = renderTable();
    return (
        <>
            <div className='title-buttons-wrapper'>
                <div className=''>
                    <Box className='tabBox'>
                        <Box>
                            <Tabs className={classes.buttonsTab} value={info?.tab ? info?.tab : 0}
                                  onChange={handleChangeTabs}
                                  aria-label='basic tabs example'
                            >
                                <Tab className='tab' label='Order Errors' {...tabProps(0)} />
                                <Tab className='tab' label='Price Errors' {...tabProps(1)} />
                            </Tabs>
                        </Box>
                    </Box>
                </div>
            </div>

            <FullTable
                head={renderTableValues?.head}
                body={renderTableValues?.body}
                loadingType={renderTableValues?.actionType}
                list={renderTableValues?.list}
                listCount={renderTableValues?.count}
                noText={renderTableValues?.noText}
            />
        </>
    );
};
